import Cookies from 'cookies-js'
import { isEmpty } from 'lodash-es'

const getAbsoluteUrl = (src, siteUrl = '') => {
  if (
    /^(http(s)?)/gi.test(src) ||
    /^(data:image)/gi.test(src) ||
    isEmpty(src)
  ) {
    return src
  }

  return `${siteUrl}${src}`
}

const getApiBaseUrl = () => {
  return Cookies.get('api_base_url') || ''
}

export { getAbsoluteUrl, getApiBaseUrl }
